// extracted by mini-css-extract-plugin
export default {"chartList":"Index-module__chartList--RemPq","chartListItem":"Index-module__chartListItem--aHSZR","titleContainer":"Index-module__titleContainer--o4km6"};